import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const REGRAS_SENHA = [
  { regex: /.{8,}/, label: 'Mínimo 8 caracteres' },
  { regex: /[A-Z]/, label: 'Uma letra maiúscula' },
  { regex: /[a-z]/, label: 'Uma letra minúscula' },
  { regex: /[0-9]/, label: 'Um número' },
  { regex: /[^A-Za-z0-9]/, label: 'Um caractere especial' },
];

function corAvatar(email) {
  let hash = 0;
  for (let i = 0; i < (email || '').length; i++) {
    hash = (email || '').charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${Math.abs(hash) % 360}, 60%, 45%)`;
}

function iniciais(nome) {
  return (nome || '').trim().split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');
}

function formatarData(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

function resizeImagem(file, maxSize = 256) {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const size = Math.min(img.width, img.height);
      const offsetX = (img.width - size) / 2;
      const offsetY = (img.height - size) / 2;
      canvas.width = maxSize;
      canvas.height = maxSize;
      ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, maxSize, maxSize);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.src = url;
  });
}

function Perfil({ onPerfilAtualizado }) {
  const [perfil, setPerfil] = useState(null);
  const [formDados, setFormDados] = useState({ nome: '', email: '' });
  const [formSenha, setFormSenha] = useState({ senha_atual: '', nova_senha: '', confirmacao: '' });
  const [salvandoDados, setSalvandoDados] = useState(false);
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [salvandoNotif, setSalvandoNotif] = useState(false);
  const [uploadandoFoto, setUploadandoFoto] = useState(false);
  const [hoverAvatar, setHoverAvatar] = useState(false);
  const inputFotoRef = useRef(null);

  useEffect(() => {
    api.get('/auth/perfil').then(res => {
      setPerfil(res.data);
      setFormDados({ nome: res.data.nome, email: res.data.email });
    }).catch(() => toast.error('Erro ao carregar perfil.'));
  }, []);

  async function salvarDados() {
    if (!formDados.nome.trim() || !formDados.email.trim()) {
      toast.error('Nome e e-mail são obrigatórios.'); return;
    }
    setSalvandoDados(true);
    try {
      const res = await api.put('/auth/perfil/dados', formDados);
      const usuarioAtualizado = { ...JSON.parse(sessionStorage.getItem('usuario')), nome: res.data.nome, email: res.data.email };
      sessionStorage.setItem('usuario', JSON.stringify(usuarioAtualizado));
      setPerfil(p => ({ ...p, nome: res.data.nome, email: res.data.email }));
      if (onPerfilAtualizado) onPerfilAtualizado(usuarioAtualizado);
      toast.success('Dados atualizados!');
    } catch (err) {
      toast.error(err.response?.data?.mensagem || 'Erro ao salvar.');
    }
    setSalvandoDados(false);
  }

  async function salvarSenha() {
    if (!formSenha.senha_atual || !formSenha.nova_senha || !formSenha.confirmacao) {
      toast.error('Preencha todos os campos.'); return;
    }
    setSalvandoSenha(true);
    try {
      await api.put('/auth/perfil/senha', formSenha);
      setFormSenha({ senha_atual: '', nova_senha: '', confirmacao: '' });
      toast.success('Senha alterada com sucesso!');
    } catch (err) {
      toast.error(err.response?.data?.mensagem || 'Erro ao alterar senha.');
    }
    setSalvandoSenha(false);
  }

  async function salvarNotif(valor) {
    setSalvandoNotif(true);
    try {
      await api.put('/auth/perfil/notificacoes', { receber_notificacoes: valor });
      setPerfil(p => ({ ...p, receber_notificacoes: valor }));
      toast.success(valor ? 'Notificações ativadas!' : 'Notificações desativadas!');
    } catch {
      toast.error('Erro ao salvar preferência.');
    }
    setSalvandoNotif(false);
  }

  async function handleFotoSelecionada(e) {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('Imagem muito grande. Máximo 5MB.'); return; }
    setUploadandoFoto(true);
    try {
      const base64 = await resizeImagem(file);
      const res = await api.post('/auth/perfil/foto', { foto: base64 });
      const usuarioAtualizado = { ...JSON.parse(sessionStorage.getItem('usuario')), foto: res.data.foto };
      sessionStorage.setItem('usuario', JSON.stringify(usuarioAtualizado));
      setPerfil(p => ({ ...p, foto: res.data.foto }));
      if (onPerfilAtualizado) onPerfilAtualizado(usuarioAtualizado);
      toast.success('Foto atualizada!');
    } catch {
      toast.error('Erro ao salvar foto.');
    }
    setUploadandoFoto(false);
    e.target.value = '';
  }

  if (!perfil) return <div style={{ padding: 40, color: '#6b7280' }}>Carregando...</div>;

  const cor = corAvatar(perfil.email);

  return (
    <div style={{ maxWidth: 560 }}>
      <h2 style={{ margin: '0 0 24px' }}>👤 Meu Perfil</h2>

      {/* Cabeçalho */}
      <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 20 }}>
        <div
          style={{ position: 'relative', flexShrink: 0, cursor: 'pointer', width: 72, height: 72 }}
          onClick={() => inputFotoRef.current?.click()}
          onMouseEnter={() => setHoverAvatar(true)}
          onMouseLeave={() => setHoverAvatar(false)}
          title="Clique para alterar foto"
        >
          {perfil.foto ? (
            <img src={perfil.foto} alt="avatar" style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', display: 'block' }} />
          ) : (
            <div style={{
              width: 72, height: 72, borderRadius: '50%', background: cor,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontSize: 24, fontWeight: 700,
            }}>
              {iniciais(perfil.nome)}
            </div>
          )}
          <div style={{
            position: 'absolute', inset: 0, borderRadius: '50%',
            background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            opacity: (hoverAvatar || uploadandoFoto) ? 1 : 0,
            transition: 'opacity 0.2s',
            fontSize: 20,
          }}>
            {uploadandoFoto ? '⏳' : '📷'}
          </div>
          <input
            ref={inputFotoRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFotoSelecionada}
          />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 18, color: '#111827' }}>{perfil.nome}</div>
          <div style={{ fontSize: 13, color: '#6b7280', marginTop: 2 }}>{perfil.email}</div>
          <div style={{ display: 'flex', gap: 24, marginTop: 10, flexWrap: 'wrap' }}>
            <div style={{ fontSize: 12 }}>
              <div style={{ color: '#9ca3af', fontWeight: 600, marginBottom: 2 }}>Membro desde</div>
              <div style={{ color: '#374151', fontWeight: 500 }}>{formatarData(perfil.created_at)}</div>
            </div>
            <div style={{ fontSize: 12 }}>
              <div style={{ color: '#9ca3af', fontWeight: 600, marginBottom: 2 }}>Último acesso</div>
              <div style={{ color: '#374151', fontWeight: 500 }}>{formatarData(perfil.ultimo_acesso)}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Dados pessoais */}
      <div className="card" style={{ marginBottom: 20 }}>
        <h3 style={{ marginBottom: 16 }}>Dados pessoais</h3>
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Nome</label>
        <input
          value={formDados.nome}
          onChange={e => setFormDados(f => ({ ...f, nome: e.target.value }))}
          placeholder="Seu nome completo"
        />
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>E-mail</label>
        <input
          type="email"
          value={formDados.email}
          onChange={e => setFormDados(f => ({ ...f, email: e.target.value }))}
          placeholder="seu@email.com"
        />
        <button className="btn-primary" onClick={salvarDados} disabled={salvandoDados}>
          {salvandoDados ? 'Salvando...' : 'Salvar alterações'}
        </button>
      </div>

      {/* Notificações */}
      <div className="card" style={{ marginBottom: 20 }}>
        <h3 style={{ marginBottom: 8 }}>🔔 Notificações por e-mail</h3>
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>
          Receba um e-mail diário às 8h com alertas de obras e pagamentos que precisam de atenção.
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div
            onClick={() => !salvandoNotif && salvarNotif(!perfil.receber_notificacoes)}
            style={{
              width: 44, height: 24, borderRadius: 12,
              background: perfil.receber_notificacoes ? 'var(--azul-medio)' : '#d1d5db',
              position: 'relative', transition: 'background 0.2s',
              cursor: salvandoNotif ? 'not-allowed' : 'pointer', flexShrink: 0,
            }}
          >
            <div style={{
              position: 'absolute', top: 3,
              left: perfil.receber_notificacoes ? 23 : 3,
              width: 18, height: 18, borderRadius: '50%',
              background: '#fff', transition: 'left 0.2s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
            }} />
          </div>
          <span style={{ fontSize: 14, fontWeight: 600, color: perfil.receber_notificacoes ? 'var(--azul-medio)' : '#6b7280' }}>
            {perfil.receber_notificacoes ? 'Ativadas' : 'Desativadas'}
          </span>
        </div>
      </div>

      {/* Alterar senha */}
      <div className="card">
        <h3 style={{ marginBottom: 16 }}>Alterar senha</h3>
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Senha atual</label>
        <input
          type="password"
          value={formSenha.senha_atual}
          onChange={e => setFormSenha(f => ({ ...f, senha_atual: e.target.value }))}
          placeholder="••••••••"
        />
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Nova senha</label>
        <input
          type="password"
          value={formSenha.nova_senha}
          onChange={e => setFormSenha(f => ({ ...f, nova_senha: e.target.value }))}
          placeholder="••••••••"
        />
        {formSenha.nova_senha.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 }}>
            {REGRAS_SENHA.map(r => (
              <span key={r.label} style={{ fontSize: 12, color: r.regex.test(formSenha.nova_senha) ? '#16a34a' : '#9ca3af' }}>
                {r.regex.test(formSenha.nova_senha) ? '✓' : '○'} {r.label}
              </span>
            ))}
          </div>
        )}
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Confirmar nova senha</label>
        <input
          type="password"
          value={formSenha.confirmacao}
          onChange={e => setFormSenha(f => ({ ...f, confirmacao: e.target.value }))}
          placeholder="••••••••"
        />
        {formSenha.confirmacao && formSenha.nova_senha !== formSenha.confirmacao && (
          <p style={{ fontSize: 12, color: '#dc2626', marginBottom: 8 }}>As senhas não coincidem.</p>
        )}
        <button className="btn-primary" onClick={salvarSenha} disabled={salvandoSenha}>
          {salvandoSenha ? 'Salvando...' : 'Alterar senha'}
        </button>
      </div>
    </div>
  );
}

export default Perfil;
